import { Component, type ReactNode } from 'react';
import { useRecargaPendente } from '../lib/recuperacao.js';
import { Logo } from './Logo.js';

/**
 * Limite de erro: um erro inesperado troca **só** o que está dentro dele pela tela de
 * recuperação, em vez de derrubar a página inteira (ADR-0032).
 *
 * Antes não existia nenhum: qualquer erro de renderização deixava a TV ou o painel
 * **em branco para sempre**, até alguém ir até a tela e recarregar à mão — numa TV
 * de sala de espera, pelo controle remoto, procurando o botão do navegador.
 *
 * O React só oferece isso como componente de classe; é o único do projeto, e por isso.
 */
export class LimiteDeErro extends Component<
  { readonly fallback: ReactNode; readonly children: ReactNode },
  { readonly erro: boolean }
> {
  override state = { erro: false };

  static getDerivedStateFromError(): { erro: boolean } {
    return { erro: true };
  }

  override render(): ReactNode {
    return this.state.erro ? this.props.fallback : this.props.children;
  }
}

/**
 * Recarrega assim que for seguro — servidor respondendo, e sem laço. Não desenha
 * nada: entra dentro de qualquer tela de recuperação.
 */
export function RecarregarQuandoPuder(): ReactNode {
  useRecargaPendente(true, true);
  return null;
}

/**
 * A recuperação do **painel**: calma, com a marca, e curta.
 *
 * No painel quem está olhando é a equipe, e dizer o que está acontecendo ajuda — ao
 * contrário da TV, onde a sala de espera não precisa saber de nada.
 */
export function PainelSeRecuperando(): ReactNode {
  return (
    <div className="flex min-h-dvh flex-col items-center justify-center gap-4 bg-canvas px-6 text-center">
      <RecarregarQuandoPuder />
      <Logo className="h-10 w-auto" />
      <p className="max-w-sm text-sm leading-relaxed text-ink-soft">
        O painel está se atualizando. Isto leva só alguns segundos — não é preciso fazer nada.
      </p>
    </div>
  );
}
